module.exports = __webpack_public_path__ + "files/04b273bca14cbdba6b0bf4d721d16ead.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-700italic.svg
 ** module id = 962
 ** module chunks = 0
 **/